
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import {ftHost} from '../../../util/helpers'

export default {
  computed: {
    selectedOrientation: {
      get () {
        if (!this.value.orientation) this.$set(this.value, 'orientation', 'PORTRAIT')
        return this.value.orientation || 'PORTRAIT'
      },
      set (val) {
        this.$set(this.value, 'orientation', val)
      }
    },
    pdfOrientations () {
      return [
        {
          name: 'Portrait',
          value: 'PORTRAIT'
        },
        {
          name: 'Landscape',
          value: 'LANDSCAPE'
        }
      ]
    },
    selectedPaperSize: {
      get () {
        if (!this.value.paperSize) this.$set(this.value, 'paperSize', 'LETTER')
        return this.value.paperSize || 'LETTER'
      },
      set (val) {
        this.$set(this.value, 'paperSize', val)
      }
    },
    pdfPaperSizes () {
      return [
        {
          name: 'Letter (8.5" x 11")',
          value: 'LETTER'
        },
        {
          name: 'Legal (8.5" x 14")',
          value: 'LEGAL'
        },
        {
          name: 'Tabloid (11" x 17")',
          value: 'TABLOID'
        },
        {
          name: 'A3 (11.7" x 16.5")',
          value: 'A3'
        },
        {
          name: 'A4 (8.3" x 11.7")',
          value: 'A4'
        }
      ]
    }
  },
  methods: {
    printReport () {
      console.log('Printing Report')
      window.print()
    },
    outputXLS () {
      this.source = this.$refs.reportDialog.$refs.reportTable
      var wb = XLSX.utils.table_to_book(this.source, {sheet: this.title, raw: true})
      // var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'})
      // return XLSX.write(wb, {bookType: 'XLSX', bookSST: true, type: 'base64'})
      return XLSX.writeFile(wb, this.getFileName() + '.xlsx')
    },
    outputCSV () {
      this.source = this.$refs.reportDialog.$refs.reportTable
      var wb = XLSX.utils.table_to_book(this.source, {sheet: this.title, raw: true})
      // we can pass options through like this {FS: ','} (which is the default) but there doesn't appear to be support for specifying a char for field wrapping...
      // looks like we could possibly add it ourselves and try to push upstream
      // bit/90_utils.js in make_csv_row
      var csv = XLSX.utils.sheet_to_csv(wb.Sheets[wb.SheetNames[0]], {FS: ','})
      console.log('csv=' + csv)
      FileSaver.saveAs(new Blob([this.s2ab(csv)], {type: 'application/octet-stream'}), this.getFileName() + '.csv')
    },
    s2ab (s) {
      var buf = new ArrayBuffer(s.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
      return buf
    },
    getReportHtml () {
      const styles = [].slice.call(document.querySelectorAll('link[rel=stylesheet]')).reduce((result, el) => result + el.outerHTML, '') +
        [].slice.call(document.getElementsByTagName('style')).reduce((result, el) => result + el.outerHTML, '') +
        // Include links to fonts that client (like wkhtmltopdf) may not have
        '<link href="https://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet">'
      const reportHtml = this.$refs.reportDialog.$refs.reportContainer.outerHTML
      return '<html lang="en" class="ft-report-active">' +
        '<base href="' + ftHost() + '/' + this.$ftAPI().appMode() + '_' + this.$ftAPI().getClub() + '/">' +
        '<head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge">' + styles + '</head>' +
        '<body>' + reportHtml + '</body></html>'
    },
    exportToPdfCommand (afterLoad, sendInEmail) {
      const fileName = this.getFileName()
      return {
        command: sendInEmail ? 'htmlReportToPdfToEmail' : 'htmlToPdf',
        requestType: 'text/html; charset=UTF-8', // We're sending HTML
        responseType: sendInEmail ? null : 'arraybuffer', // If exporting PDF, we'll be getting binary (arraybuffer in Axios), else sending email will respond with text/json (default)
        params: {
          rcpts: this.value.rcpts,
          subject: this.value.subject,
          message: this.value.message,
          filename: fileName + '.pdf',
          senderName: this.$ftUser.name,
          senderEmail: this.$ftUser.email,
          orientation: this.selectedOrientation,
          size: this.selectedPaperSize,
          footer_left: this.reportDateTime.format('YYYY-MM-DD'),
          footer_right: '[page]/[topage]'
        },
        load: (r) => {
          // only attempt to save a file if we are not sending via email. sendInEmail is true when sending email, undefined when downloading
          if (sendInEmail === undefined) FileSaver.saveAs(new Blob([r], {type: 'application/pdf'}), fileName + '.pdf')
          if (typeof afterLoad === 'function') afterLoad()
        },
        loading: this.setIsLoading
      }
    },
    getFileName () {
      return this.title + '-' + (this.selectedSavedReportName ? this.selectedSavedReportName + '-' : '') + this.reportDateTime.format('YYYY-MM-DD HHmmss')
    },
    exportAsPdf () {
      this.saveAsPdf(() => {this.showExportPdfDialog = false})
    },
    saveAsPdf (afterLoad, sendInEmail) {
      // Execute after timeout to give form elements a chance to update
      setTimeout(() => {
        // Give lazy form elements even more of a chance to update before submitting
        setTimeout(() => {
          this.$ftAPI().export(this.addResourceErrorHandler(this.exportToPdfCommand(afterLoad, sendInEmail)), this.getReportHtml())
        }, 0)
      }, 0)
    },
    sendEmail () {
      this.saveAsPdf(() => {this.showEmailDialog = false}, true)
    }
  }
}
